import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { DesignSystemProvider } from '@asus-common/fe-ui-shadcn'
import { useState, type ReactNode } from 'react'
import i18n from '@/i18n'

interface ProvidersProps {
  children: ReactNode
}

export function Providers({ children }: ProvidersProps) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 30_000,
          },
          mutations: {
            retry: 0,
          },
        },
      }),
  )

  return (
    <QueryClientProvider client={queryClient}>
      <DesignSystemProvider translate={key => i18n.t(key)}>
        {children}
      </DesignSystemProvider>
    </QueryClientProvider>
  )
}
